import React, { useEffect, useState } from 'react'
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuInput } from '../../../../Components/Utils/Input';
import { CountryMIN } from '../../../../assets/CountryMini';
import Pagination from '../../../../Components/Utils/Pagenation';
import CardView from './cardView';
import ImportMembers from './Import';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { GetAccess } from '../../../../Components/Utils/roles';
import ContactsLayout from '../ContactsLayout';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { useFormik } from 'formik';
import useFetchMetaStarIndex from '../../../../Components/Hooks/useFetchMetaStarIndex';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import { useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import UseGetDataSearchByPro from '../../../../Components/Hooks/useFetchDataByPRO';
import CreateRentalManpower from './createRentalManpower';

function Index() {
  const [open, setOpen] = useState(false);
   const location = useLocation();
   const state = location.state;
  const {officeId} = useParams();
   const currentPage= location.state?.currentPage
   const searchQuery= location.state?.searchQuery
   const [page, setPage] = useState(currentPage||1)
   const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
   const [filter, setFilter] = useState(state?.industry?true:false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
    const {value:Status} = useFetchMDIndex(`/dropdown/dropdown-details/`,'Status_Customer',showFilterDialog)
    const [createModalOpen, setCreateModalOpen] = useState(false); // State to handle modal open/close
  
  const [filterProps, setFilterProps] = useState({
    country:"",
    category:"",
    paymentTerm:"",
    ratings:"",
    status:"",
    industry:"",
    customerType:"",
    approvalStatus:"",

  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search:searchQuery||"",

    searchBy: "",
    country:"",
    // category:state?.category? state.category :"",

    category:"",
    paymentTerm:"",
    ratings:"",
    status:"",
    industry:state?.industry? state.industry :"",
    customerType:"",
    approvalStatus:"",

  });
  const clearFilter = ()=> {
    setParams({...params, country:"",
    category:"",
    paymentTerm:"",
    ratings:"",
    status:"",
    industry:"",
    approvalStatus:"",

    customerType:""})
    formik.values.status=""
    formik.values.customerType=""
    formik.values.category=""
    formik.values.paymentTerm=""
    formik.values.industry=""
    formik.values.country=""
    formik.values.ratings=""
    formik.values.approvalStatus=""



      setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,country:value.country, industry:value.industry,paymentTerm:value.paymentTerm,category:value.category,ratings:value.ratings,status:value.status,customerType:value.customerType,approvalStatus:value.approvalStatus})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        country:"",
        category:"",
        paymentTerm:"",
        ratings:"",
        status:"",
        industry:"",
        customerType:"",
        approvalStatus:""
      });
    }
  })

  const { data, totalCount, getData,dataLoading } = UseGetDataSearchByPro( `/manpower-role/`, params );
  const [viewMode, setViewMode] = useState(localStorage.getItem("viewMode") || "card");
  const defaultHeader = [
    {
      title: "ID",
      width: "5%",
      field: "id",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Job Role",
      width: "10%",
      isLink: true,
      id: "id",
      link: `/main/${officeId}/contacts/rental-man/view/`,
      field: "job_role",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Type ",
      width: "10%",
      field: "type",
      isRM: true,
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Working Hours ",
      width: "10%",
      field: "working_hours",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Amount Per Hour ",
      width: "10%",
      type:"amount",
      field: "amount_per_hour",
      textAlign: "center",
      rowAlign: "center",
    },
    
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"id",
        removeValue:"job_role",
        url:`/manpower-role/`,
        moduleName:"rentalManpower",
        from:`/main/${officeId}/contacts/rental-man`,
        editLink:`/main/${officeId}/contacts/rental-man/edit/`,
        viewLink:`/main/${officeId}/contacts/rental-man/view/`

      }
    },
  ];
  const availableHeaders = [
   
  ];
  useEffect(()=>{
    localStorage.setItem("viewMode", viewMode);
     setParams({...params,page:page,per_page:pageCount})
 },[page,pageCount,viewMode])

 const closeFilterDialog = () => {
  setShowFilterDialog(false);
};
const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

 const [valueOfSearch,setValuesofSearch] = useState("")
   function searchFunction(e) {
 
     
     setValuesofSearch(e?.target?.value)
     setParams({ ...params, search: e?.target?.value, page:1 });
     setPage(1)
   }
  return (
    <>
    <ContactsLayout 

     setOpen={setShowImportModal}
          searchFun={searchFunction}
          getData={getData}
          isCard={true}
          isFilter={filter}
           newfilter={true}
          setFilterOpen={setShowFilterDialog}
          ClearFilter={clearFilter}
          CreateAccess={GetAccess("rental_manpower_create")}
          ImportAccess={GetAccess("rental_manpower_create")}
          officeId={officeId}
          searchValue={valueOfSearch}
          setViewMode={setViewMode}
          // searchBy={searchBy}
          viewMode={viewMode}
          onCreateClick={() => setCreateModalOpen(true)} 
          >
    <div className='w-full h-full '>
      
      {viewMode === "list" ? (
      <CustomDataTable 

        fetcher={getData}
        data={data} 
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeader}
        bodyHeight='max-h-[calc(100vh-260px)]'
        height='h-[calc(100vh-160px)]'
        total={totalCount}
        pageIndex={params.page}
        setPageIndex={setPage}
        dataCount={params.per_page}
        setDataCount={setPageCount}
        // title='Client List'
        storageName="ManpowerTable"
        editAccess="rental_manpower_edit"      
        deteleAccess="rental_manpower_delete" 
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}

        />
      ) : (
        <>
        <div className='w-full h-[calc(100vh-210px)] rounded-md bg-white p-3 mt-4 relative overflow-y-scroll'>
       <div className='flex gap-40'>
      
        <p className='text-xs font-semibold text-[#111537] text-left'>Rental Manpower : {totalCount}</p>
        {/* <p className='text-sm'>Credit : {}</p>
         <p className='text-sm'>Advance : {}</p>
         */}

       
        </div>
          <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4'>
            
            {data && data.map((item, idx) => (
              <CardView fetcher={getData} item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[40px] rounded-b-md bg-white">
          <Pagination
            total={totalCount}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </>
      )}
      </div>
      </ContactsLayout>
      <CreateRentalManpower 
          open={createModalOpen}
          onCancel={() => {
            setCreateModalOpen(false);
          }}
          // projectList={projectList || []}
          getData={getData}
          // firstProject={firstProject}
        />
          {showImportModal && (<ImportMembers  show={showImportModal} onClose={closeModal} getData={getData} />)}
          </>
  )
}
export default Index